type Dict = {
    [key: string]: string
}

export interface PeriodicElement {
    nazwa: Dict;
    snazwa: Dict;
    kategoria: Dict;
    postac: Dict;
    wyst_w_przyrodzie: Dict;

    symbol: string;
    grupa: number;
    okres: number;
    kategoria_code: string;
    masa_atomowa: string;
    gestosc: string;
    temp_topnienia: string;
    temp_wrzenia: string;
    odkryty_przez: string;
    rok_odkrycia: string;
    elektrony: number;
    protony: number;
    neutrony: number;
    liczba_powlok: number;
    rozklad_powlok: string;

    temp_topnieniaPL?: string;
    gestoscPL?: string
};

export const DATA: PeriodicElement[] = [
    {
        "symbol": "H",
        "kategoria_code": "niemetale",
        "grupa": 1,
        "okres": 1,
        "gestosc": "0.00008988 g/cm³",
        "temp_topnienia": "-259.34°C",
        "temp_wrzenia": "-259.34°C",
        "odkryty_przez": "Henry Cavendish",
        "rok_odkrycia": "1766",
        "elektrony": 1,
        "protony": 1,
        "neutrony": 0,
        "liczba_powlok": 1,
        "rozklad_powlok": "1",
        "masa_atomowa": "1.00800 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetal"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Wodór (H)1",
            "en": "Hydrogen (H)1"
        },
        "snazwa": {
            "pl": "Wodór",
            "en": "Hydrogen"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "He",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 1,
        "gestosc": "0.0001785 g/cm³",
        "temp_topnienia": "-272.2 °C",
        "temp_wrzenia": "-268.93 °C",
        "odkryty_przez": "William Ramsay, Norman Lockyer, Per Teodor Cleve, Pierre Janssen",
        "rok_odkrycia": "1868",
        "elektrony": 2,
        "protony": 2,
        "neutrony": 2,
        "liczba_powlok": 1,
        "rozklad_powlok": "2",
        "masa_atomowa": "4.00260 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Hel (He)2",
            "en": "Helium (He)2"
        },
        "snazwa": {
            "pl": "Hel",
            "en": "Helium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Li",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 2,
        "gestosc": "0.534 g/cm3",
        "temp_topnienia": "180.50°C",
        "temp_wrzenia": "1342 °C",
        "odkryty_przez": "Johan August Arfwedson",
        "rok_odkrycia": "1817",
        "elektrony": 3,
        "protony": 3,
        "neutrony": 4,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,1",
        "masa_atomowa": "7.00000 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Lit (Li)3",
            "en": "Lithium (Li)3"
        },
        "snazwa": {
            "pl": "Lit",
            "en": "Lithium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Be",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 2,
        "gestosc": "1.85 g/cm3",
        "temp_topnienia": "1287.00°C",
        "temp_wrzenia": "2471°C",
        "odkryty_przez": "Humphry Davy, Joseph Louis Gay-Lussac, Louis Jacques Thénard",
        "rok_odkrycia": "1808",
        "elektrony": 4,
        "protony": 4,
        "neutrony": 5,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,2",
        "masa_atomowa": "9.01218 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline earth metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Beryl (Be)4",
            "en": "Beryl (Be)4"
        },
        "snazwa": {
            "pl": "Beryl",
            "en": "Beryl"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "B",
        "kategoria_code": "polmetale",
        "grupa": 13,
        "okres": 2,
        "gestosc": "2.37 g/cm3",
        "temp_topnienia": "2075.00°C",
        "temp_wrzenia": "4000°C",
        "odkryty_przez": "Humphry Davy, Joseph Louis Gay-Lussac, Louis Jacques Thénard",
        "rok_odkrycia": "1808",
        "elektrony": 5,
        "protony": 5,
        "neutrony": 6,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,3",
        "masa_atomowa": "10.81100 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Bor (B)5",
            "en": "Bor (B)5"
        },
        "snazwa": {
            "pl": "Bor",
            "en": "Bor"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "C",
        "kategoria_code": "niemetale",
        "grupa": 14,
        "okres": 2,
        "gestosc": "2.2670 g/cm³",
        "temp_topnienia": "3550.00°C",
        "temp_wrzenia": "3825°C ",
        "odkryty_przez": "Smithson Tennant",
        "rok_odkrycia": "1797",
        "elektrony": 6,
        "protony": 6,
        "neutrony": 6,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,4",
        "masa_atomowa": "12.01100 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Węgiel (C) 6",
            "en": "Carbon (C) 6"
        },
        "snazwa": {
            "pl": "Węgiel",
            "en": "Carbon"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "N ",
        "kategoria_code": "niemetale",
        "grupa": 15,
        "okres": 2,
        "gestosc": "0.0012506 g/cm³",
        "temp_topnienia": "-210.00°C",
        "temp_wrzenia": "-195.79 °C",
        "odkryty_przez": "Daniel Rutherford",
        "rok_odkrycia": "1772",
        "elektrony": 7,
        "protony": 7,
        "neutrony": 7,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,5",
        "masa_atomowa": "14.00700 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Azot (N)7",
            "en": "Nitrogen (N)7"
        },
        "snazwa": {
            "pl": "Azot",
            "en": "Nitrogen"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "O",
        "kategoria_code": "niemetale",
        "grupa": 16,
        "okres": 2,
        "gestosc": "0.001429 g/cm³",
        "temp_topnienia": "-218.79°C",
        "temp_wrzenia": "-182.95°C ",
        "odkryty_przez": "Henry Cavendish",
        "rok_odkrycia": "1766",
        "elektrony": 8,
        "protony": 8,
        "neutrony": 8,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,6",
        "masa_atomowa": "15.999 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Tlen (O)8",
            "en": "Oxygen (O)8"
        },
        "snazwa": {
            "pl": "Tlen",
            "en": "Oxygen"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "F",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 2,
        "gestosc": "0.001696 g/cm³",
        "temp_topnienia": "-219.62°C",
        "temp_wrzenia": "-188.12°C ",
        "odkryty_przez": "Henri Moissan",
        "rok_odkrycia": "1886",
        "elektrony": 9,
        "protony": 9,
        "neutrony": 10,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,7",
        "masa_atomowa": "18.99840316 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Fluor (F)9",
            "en": "Fluorine (F)9"
        },
        "snazwa": {
            "pl": "Fluor",
            "en": "Fluorine"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ne",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 2,
        "gestosc": "0.0008999 g/cm³",
        "temp_topnienia": "-248.59°C",
        "temp_wrzenia": "-246.08°C",
        "odkryty_przez": "William Ramsay, Morris Travers",
        "rok_odkrycia": "1898",
        "elektrony": 10,
        "protony": 10,
        "neutrony": 10,
        "liczba_powlok": 2,
        "rozklad_powlok": "2,8",
        "masa_atomowa": "20.180 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Neon (Ne)10",
            "en": "Neon (Ne)10"
        },
        "snazwa": {
            "pl": "Neon",
            "en": "Neon"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Na ",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 3,
        "gestosc": "0.97 g/cm³",
        "temp_topnienia": "97.80°C",
        "temp_wrzenia": "883°C",
        "odkryty_przez": "Humphry Davy",
        "rok_odkrycia": "1807",
        "elektrony": 11,
        "protony": 11,
        "neutrony": 12,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,1",
        "masa_atomowa": "22.9897693 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Sód (Na)11",
            "en": "Sodium (Na)11"
        },
        "snazwa": {
            "pl": "Sód",
            "en": "Sodium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Mg",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 3,
        "gestosc": "1.74 g/cm³",
        "temp_topnienia": "650°C ",
        "temp_wrzenia": "1090°C",
        "odkryty_przez": "Humphry Davy, Joseph Black",
        "rok_odkrycia": "1755",
        "elektrony": 12,
        "protony": 12,
        "neutrony": 12,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,2",
        "masa_atomowa": "24.305 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline earth metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Magnez (Mg)12",
            "en": "Magnesium (Mg)12"
        },
        "snazwa": {
            "pl": "Magnez",
            "en": "Magnesium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Al",
        "kategoria_code": "metale-bloku-p",
        "grupa": 13,
        "okres": 3,
        "gestosc": "2.70 g/cm³",
        "temp_topnienia": "660.323°C",
        "temp_wrzenia": "2519°C ",
        "odkryty_przez": "Hans Christian Ørsted",
        "rok_odkrycia": "1825",
        "elektrony": 13,
        "protony": 13,
        "neutrony": 14,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,3",
        "masa_atomowa": "26.981538 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Glin (Al)13",
            "en": "Aluminium (Al)13"
        },
        "snazwa": {
            "pl": "Glin",
            "en": "Aluminium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Si",
        "kategoria_code": "polmetale",
        "grupa": 14,
        "okres": 3,
        "gestosc": "2.3296 g/cm³",
        "temp_topnienia": "1414°C ",
        "temp_wrzenia": "3265°C",
        "odkryty_przez": "Antoine Lavoisier, Jöns Jacob Berzelius",
        "rok_odkrycia": "1823",
        "elektrony": 14,
        "protony": 14,
        "neutrony": 14,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,4",
        "masa_atomowa": "28.085 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Krzem (Si) 14",
            "en": "Silicon (Si)14"
        },
        "snazwa": {
            "pl": "Krzem",
            "en": "Silicon"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "P",
        "kategoria_code": "niemetale",
        "grupa": 15,
        "okres": 3,
        "gestosc": "1.82 g/cm³",
        "temp_topnienia": "44.15°C ",
        "temp_wrzenia": "280.5°C ",
        "odkryty_przez": "Hennig Brand",
        "rok_odkrycia": "1669",
        "elektrony": 15,
        "protony": 15,
        "neutrony": 16,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,5",
        "masa_atomowa": "30.97376200 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Fosfor (P)15",
            "en": "Phosphorus (P)15"
        },
        "snazwa": {
            "pl": "Fosfor",
            "en": "Phosphorus"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "S",
        "kategoria_code": "niemetale",
        "grupa": 16,
        "okres": 3,
        "gestosc": "2.067 g/cm³",
        "temp_topnienia": "115.21°C",
        "temp_wrzenia": "444.60°C ",
        "odkryty_przez": "Louis-Joseph Gay-Lussac and Louis-Jacques Thenard",
        "rok_odkrycia": "1809",
        "elektrony": 16,
        "protony": 16,
        "neutrony": 16,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,6",
        "masa_atomowa": "32.07 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Siarka (S)16",
            "en": "Sulfur (S)16"
        },
        "snazwa": {
            "pl": "Siarka",
            "en": "Sulfur"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Cl",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 3,
        "gestosc": "0.003214 g/cm³",
        "temp_topnienia": "-101.5°C",
        "temp_wrzenia": "-34.04°C",
        "odkryty_przez": "Carl Wilhelm Scheele",
        "rok_odkrycia": "1774",
        "elektrony": 17,
        "protony": 17,
        "neutrony": 18,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,7",
        "masa_atomowa": "35.45 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Chlor (Cl)17",
            "en": "Chlorine (Cl)17"
        },
        "snazwa": {
            "pl": "Chlor",
            "en": "Chlorine"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ar",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 3,
        "gestosc": "0.0017837 g/cm³",
        "temp_topnienia": "-189.35°C ",
        "temp_wrzenia": "-185.85°C",
        "odkryty_przez": "John William Strutt, 3rd Baron Rayleigh, William Ramsay",
        "rok_odkrycia": "1894",
        "elektrony": 18,
        "protony": 18,
        "neutrony": 22,
        "liczba_powlok": 3,
        "rozklad_powlok": "2,8,8",
        "masa_atomowa": "39.9 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Argon (Ar)18",
            "en": "Argon (Ar)18"
        },
        "snazwa": {
            "pl": "Argon",
            "en": "Argon"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "K",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 4,
        "gestosc": "0.89 g/cm³",
        "temp_topnienia": "63.38°C",
        "temp_wrzenia": "759°C ",
        "odkryty_przez": "Humphry Davy",
        "rok_odkrycia": "1807",
        "elektrony": 19,
        "protony": 19,
        "neutrony": 20,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,8,1",
        "masa_atomowa": "39.0983 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Potas (K)19",
            "en": "Potassium (K)19"
        },
        "snazwa": {
            "pl": "Potas",
            "en": "Potassium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ca",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 4,
        "gestosc": "1.54 g/cm³",
        "temp_topnienia": "842°C",
        "temp_wrzenia": "1484°C",
        "odkryty_przez": "Humphry Davy",
        "rok_odkrycia": "1808",
        "elektrony": 20,
        "protony": 20,
        "neutrony": 20,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,8,2",
        "masa_atomowa": "40.08 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline Earth Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Wapń (Ca)20",
            "en": "Calcium (Ca)20"
        },
        "snazwa": {
            "pl": "Wapń",
            "en": "Calcium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Sc",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 3,
        "okres": 4,
        "gestosc": "2.99 g/cm³",
        "temp_topnienia": "1541°C",
        "temp_wrzenia": "2836°C ",
        "odkryty_przez": "Per Teodor Cleve, Lars Fredrik Nilson",
        "rok_odkrycia": "1879",
        "elektrony": 21,
        "protony": 21,
        "neutrony": 24,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,9,2",
        "masa_atomowa": "44.95591 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Scand (Sc)21",
            "en": "Scandium (Sc)21"
        },
        "snazwa": {
            "pl": "Scand",
            "en": "Scandium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Ti",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 4,
        "okres": 4,
        "gestosc": "4.5 g/cm³",
        "temp_topnienia": "1668°C ",
        "temp_wrzenia": "3287°C ",
        "odkryty_przez": "Martin Heinrich Klaproth, William Gregor",
        "rok_odkrycia": "1791",
        "elektrony": 22,
        "protony": 22,
        "neutrony": 26,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,10,2",
        "masa_atomowa": "47.867 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tytan (Ti)22",
            "en": "Titanium (Ti)22"
        },
        "snazwa": {
            "pl": "Tytan",
            "en": "Titanium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "V",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 5,
        "okres": 4,
        "gestosc": "6.0 g/cm³",
        "temp_topnienia": "1910°C",
        "temp_wrzenia": "3407°C",
        "odkryty_przez": "Andrés Manuel del Río",
        "rok_odkrycia": "1801",
        "elektrony": 23,
        "protony": 23,
        "neutrony": 28,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,11,2",
        "masa_atomowa": "50.9415 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Wanad (V)23",
            "en": "Vanadium (V)23"
        },
        "snazwa": {
            "pl": "Wanad",
            "en": "Vanadium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Cr",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 6,
        "okres": 4,
        "gestosc": "7.15 g/cm³",
        "temp_topnienia": "1907°C",
        "temp_wrzenia": "2671°C ",
        "odkryty_przez": "Louis Nicolas Vauquelin, Martin Heinrich Klaproth",
        "rok_odkrycia": "1797",
        "elektrony": 24,
        "protony": 24,
        "neutrony": 28,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,13,1",
        "masa_atomowa": "51.996 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Chrom (Cr)24",
            "en": "Chromium (Cr)24"
        },
        "snazwa": {
            "pl": "Chrom",
            "en": "Chromium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Mn",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 7,
        "okres": 4,
        "gestosc": "7.3 g/cm³",
        "temp_topnienia": "1246°C",
        "temp_wrzenia": "2061°C",
        "odkryty_przez": "Carl Wilhelm Scheele, Johan Gottlieb Gahn, Ignatius Gottfried Kaim",
        "rok_odkrycia": "1774",
        "elektrony": 25,
        "protony": 25,
        "neutrony": 30,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,13,2",
        "masa_atomowa": "54.93804 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Mangan (Mn)25",
            "en": "Manganese (Mn)25"
        },
        "snazwa": {
            "pl": "Mangan",
            "en": "Manganese"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Fe",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 8,
        "okres": 4,
        "gestosc": "7.874 g/cm³",
        "temp_topnienia": "1538°C ",
        "temp_wrzenia": "2861°C ",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 26,
        "protony": 26,
        "neutrony": 30,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,14,2",
        "masa_atomowa": "55.84 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Żelazo (Fe)26",
            "en": "Iron (Fe)26"
        },
        "snazwa": {
            "pl": "Żelazo",
            "en": "Iron"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Co",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 9,
        "okres": 4,
        "gestosc": "8.86 g/cm³",
        "temp_topnienia": "1495°C",
        "temp_wrzenia": "2927°C ",
        "odkryty_przez": "Georg Brandt",
        "rok_odkrycia": "1735",
        "elektrony": 27,
        "protony": 27,
        "neutrony": 32,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,15,2",
        "masa_atomowa": "58.93319 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Kobalt (Co)27",
            "en": "Cobalt (Co)27"
        },
        "snazwa": {
            "pl": "Kobalt",
            "en": "Cobalt"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Ni ",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 10,
        "okres": 4,
        "gestosc": "8.912 g/cm³",
        "temp_topnienia": "1455°C ",
        "temp_wrzenia": "2913°C ",
        "odkryty_przez": "Axel Fredrik Cronstedt",
        "rok_odkrycia": "1751",
        "elektrony": 28,
        "protony": 28,
        "neutrony": 31,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,16,2",
        "masa_atomowa": "58.693 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Nikiel (Ni) 28",
            "en": "Nickel (Ni) 28"
        },
        "snazwa": {
            "pl": "Nikiel",
            "en": "Nickel"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Cu",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 11,
        "okres": 4,
        "gestosc": "8.933 g/cm³",
        "temp_topnienia": "1084.62°",
        "temp_wrzenia": "2562°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 29,
        "protony": 29,
        "neutrony": 35,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,1",
        "masa_atomowa": "63.55 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Miedź (Cu)29",
            "en": "Copper  (Cu)29"
        },
        "snazwa": {
            "pl": "Miedź",
            "en": "Copper"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Zn",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 12,
        "okres": 4,
        "gestosc": "7.134 g/cm³",
        "temp_topnienia": "419.53°C ",
        "temp_wrzenia": "907°C",
        "odkryty_przez": "Andreas Sigismund Marggraf",
        "rok_odkrycia": "1746",
        "elektrony": 30,
        "protony": 30,
        "neutrony": 35,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,2",
        "masa_atomowa": "65.4 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Cynk (Zn)30",
            "en": "Zinc (Zn)30"
        },
        "snazwa": {
            "pl": "Cynk",
            "en": "Zinc"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Ga",
        "kategoria_code": "metale-bloku-p",
        "grupa": 13,
        "okres": 4,
        "gestosc": "5.91 g/cm³",
        "temp_topnienia": "29.76°C ",
        "temp_wrzenia": "2204°C ",
        "odkryty_przez": "Paul-Émile Lecoq de Boisbaudran",
        "rok_odkrycia": "1875",
        "elektrony": 31,
        "protony": 31,
        "neutrony": 39,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,3",
        "masa_atomowa": "69.723 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Gal (Ga)31",
            "en": "Gallium (Ga)31"
        },
        "snazwa": {
            "pl": "Gal",
            "en": "Gallium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Ge",
        "kategoria_code": "polmetale",
        "grupa": 14,
        "okres": 4,
        "gestosc": "5.323 g/cm³",
        "temp_topnienia": "938.25°C ",
        "temp_wrzenia": "2833°C",
        "odkryty_przez": "Clemens Winkler",
        "rok_odkrycia": "1886",
        "elektrony": 32,
        "protony": 32,
        "neutrony": 41,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,4",
        "masa_atomowa": "72.63 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "German (Ge)32",
            "en": "German (Ge)32"
        },
        "snazwa": {
            "pl": "German",
            "en": "German"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "As",
        "kategoria_code": "polmetale",
        "grupa": 15,
        "okres": 4,
        "gestosc": "5.776 g/cm³",
        "temp_topnienia": "817°C ",
        "temp_wrzenia": "614°C",
        "odkryty_przez": "Albertus Magnus",
        "rok_odkrycia": "1250",
        "elektrony": 33,
        "protony": 33,
        "neutrony": 42,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,5",
        "masa_atomowa": "74.92159 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Arsen (As)33",
            "en": "Arsenic (As)33"
        },
        "snazwa": {
            "pl": "Arsen",
            "en": "Arsenic"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Se",
        "kategoria_code": "niemetale",
        "grupa": 16,
        "okres": 4,
        "gestosc": "4.809 g/cm³",
        "temp_topnienia": "220.5°C ",
        "temp_wrzenia": "685°C ",
        "odkryty_przez": "Jöns Jacob Berzelius, Johan Gottlieb Gahn",
        "rok_odkrycia": "1817",
        "elektrony": 34,
        "protony": 34,
        "neutrony": 45,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,6",
        "masa_atomowa": "78.97 u",
        "kategoria": {
            "pl": "Niemetale",
            "en": "Nonmetals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Selen (Se) 34",
            "en": "Selenium (Se)34"
        },
        "snazwa": {
            "pl": "Selen",
            "en": "Selenium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Br",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 4,
        "gestosc": "3.11 g/cm³",
        "temp_topnienia": "-7.2°C",
        "temp_wrzenia": "58.8°C ",
        "odkryty_przez": "Antoine Jérôme Balard, Carl Jacob Löwig",
        "rok_odkrycia": "1826",
        "elektrony": 35,
        "protony": 35,
        "neutrony": 45,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,7",
        "masa_atomowa": "79.90 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "ciecz",
            "en": "liquid"
        },
        "nazwa": {
            "pl": "Brom (Br)35",
            "en": "Bromine (Br)35"
        },
        "snazwa": {
            "pl": "Brom",
            "en": "Bromine"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Kr",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 4,
        "gestosc": "0.003733 g/cm³",
        "temp_topnienia": "-157.36°C",
        "temp_wrzenia": "-153.22°C",
        "odkryty_przez": "William Ramsay, Morris Travers",
        "rok_odkrycia": "1898",
        "elektrony": 36,
        "protony": 36,
        "neutrony": 48,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,8",
        "masa_atomowa": "83.80 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Krypton (Kr)36",
            "en": "Krypton (Kr)36"
        },
        "snazwa": {
            "pl": "Krypton",
            "en": "Krypton"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Rb",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 5,
        "gestosc": "1.53 g/cm³",
        "temp_topnienia": "39.31°C",
        "temp_wrzenia": "688°C ",
        "odkryty_przez": "Gustav Kirchhoff, Robert Bunsen",
        "rok_odkrycia": "1861",
        "elektrony": 37,
        "protony": 37,
        "neutrony": 48,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,8,1",
        "masa_atomowa": "85.468 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Rubid (Rb)37",
            "en": "Rubidium (Rb)37"
        },
        "snazwa": {
            "pl": "Rubid",
            "en": "Rubidium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Sr",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 5,
        "gestosc": "2.64 g/cm³",
        "temp_topnienia": "777°C ",
        "temp_wrzenia": "1382°C",
        "odkryty_przez": "Humphry Davy, Adair Crawford, William Cruickshank",
        "rok_odkrycia": "1790",
        "elektrony": 38,
        "protony": 38,
        "neutrony": 50,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,8,2",
        "masa_atomowa": "87.62 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline Earth Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Stront (Sr)38",
            "en": "Strontium (Sr)38"
        },
        "snazwa": {
            "pl": "Stront",
            "en": "Strontium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Y",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 3,
        "okres": 5,
        "gestosc": "4.47 g/cm",
        "temp_topnienia": "1522°C",
        "temp_wrzenia": "3345°C",
        "odkryty_przez": "Johan Gadolin",
        "rok_odkrycia": "1794",
        "elektrony": 39,
        "protony": 39,
        "neutrony": 50,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,9,2",
        "masa_atomowa": "88.90584 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Itr (Y)39",
            "en": "Yttrium (Y)39"
        },
        "snazwa": {
            "pl": "Itr",
            "en": "Yttrium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Zr",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 4,
        "okres": 5,
        "gestosc": "6.52 g/cm³",
        "temp_topnienia": "1855°C ",
        "temp_wrzenia": "4409°C",
        "odkryty_przez": "Martin Heinrich Klaproth",
        "rok_odkrycia": "1789",
        "elektrony": 40,
        "protony": 40,
        "neutrony": 51,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,10,2",
        "masa_atomowa": "91.22 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Cyrkon (Zr)40",
            "en": "Zirconium (Zr)40"
        },
        "snazwa": {
            "pl": "Cyrkon",
            "en": "Zirconium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Nb",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 5,
        "okres": 5,
        "gestosc": "8.57 g/cm³",
        "temp_topnienia": "2477°C ",
        "temp_wrzenia": "4744°C",
        "odkryty_przez": "Charles Hatchett",
        "rok_odkrycia": "1801",
        "elektrony": 41,
        "protony": 41,
        "neutrony": 52,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,12,1",
        "masa_atomowa": "92.90637 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Niob (Nb)41",
            "en": "Niobum  (Nb)41"
        },
        "snazwa": {
            "pl": "Niob",
            "en": "Niobum"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Mo",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 6,
        "okres": 5,
        "gestosc": "10.2 g/cm³",
        "temp_topnienia": "2623°C",
        "temp_wrzenia": "4639°C",
        "odkryty_przez": "Carl Wilhelm Scheele",
        "rok_odkrycia": "1778",
        "elektrony": 42,
        "protony": 42,
        "neutrony": 54,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,13,1",
        "masa_atomowa": "95.95 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Molibden (Mo)42",
            "en": "Molybdenum (Mo)42"
        },
        "snazwa": {
            "pl": "Molibden",
            "en": "Molybdenum"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural "
        }
    },
    {
        "symbol": "Tc",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 7,
        "okres": 5,
        "gestosc": "11 g/cm³",
        "temp_topnienia": "2157°C ",
        "temp_wrzenia": "4265°C",
        "odkryty_przez": "Emilio Segrè, Carlo Perrier",
        "rok_odkrycia": "1937",
        "elektrony": 43,
        "protony": 43,
        "neutrony": 55,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,13,2",
        "masa_atomowa": "96.90636 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Technet (Tc)43",
            "en": "Technetium (Tc)43"
        },
        "snazwa": {
            "pl": "Technet",
            "en": "Technetium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Ru",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 8,
        "okres": 5,
        "gestosc": "12.1 g/cm³",
        "temp_topnienia": "2334°C",
        "temp_wrzenia": "4150°C",
        "odkryty_przez": "Gottfried Wilhelm Osann",
        "rok_odkrycia": "1828",
        "elektrony": 44,
        "protony": 44,
        "neutrony": 57,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,15,1",
        "masa_atomowa": "101.1 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ruten (Ru)44",
            "en": "Ruthenium (Ru)44"
        },
        "snazwa": {
            "pl": "Ruten",
            "en": "Ruthenium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Rh",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 9,
        "okres": 5,
        "gestosc": "12.4 g/cm³",
        "temp_topnienia": "1964°C ",
        "temp_wrzenia": "3695°C ",
        "odkryty_przez": "William Hyde Wollaston",
        "rok_odkrycia": "1803",
        "elektrony": 45,
        "protony": 45,
        "neutrony": 58,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,16,1",
        "masa_atomowa": "102.9055 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Rod (Rh)45",
            "en": "Rhodium (Rh)45"
        },
        "snazwa": {
            "pl": "Rod",
            "en": "Rhodium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Pd",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 10,
        "okres": 5,
        "gestosc": "12.0 g/cm³",
        "temp_topnienia": "1554.9°C",
        "temp_wrzenia": "2963°C",
        "odkryty_przez": "William Hyde Wollaston",
        "rok_odkrycia": "1803",
        "elektrony": 46,
        "protony": 46,
        "neutrony": 60,
        "liczba_powlok": 4,
        "rozklad_powlok": "2,8,18,18",
        "masa_atomowa": "106.42 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Pallad (Pd)46",
            "en": "Palladium (Pd)46"
        },
        "snazwa": {
            "pl": "Pallad",
            "en": "Palladium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Ag",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 11,
        "okres": 5,
        "gestosc": "10.501 g/cm³",
        "temp_topnienia": "961.78°C ",
        "temp_wrzenia": "2162°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 47,
        "protony": 47,
        "neutrony": 61,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,1",
        "masa_atomowa": "107.868 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Srebro (Ag)47",
            "en": "Silver (Ag)47"
        },
        "snazwa": {
            "pl": "Srebro",
            "en": "Silver"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Cd",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 12,
        "okres": 5,
        "gestosc": "8.69 g/cm³",
        "temp_topnienia": "321.07°C ",
        "temp_wrzenia": "767°C",
        "odkryty_przez": "Friedrich Stromeyer, Karl Samuel Leberecht Hermann",
        "rok_odkrycia": "1817",
        "elektrony": 48,
        "protony": 48,
        "neutrony": 64,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,2",
        "masa_atomowa": "112.41 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Kadm (Cd)48",
            "en": "Cadmium (Cd)48"
        },
        "snazwa": {
            "pl": "Kadm",
            "en": "Cadmium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "In",
        "kategoria_code": "metale-bloku-p",
        "grupa": 13,
        "okres": 5,
        "gestosc": "7.31 g/cm³",
        "temp_topnienia": "156.60°C",
        "temp_wrzenia": "2072°C ",
        "odkryty_przez": "Ferdinand Reich",
        "rok_odkrycia": "1863",
        "elektrony": 49,
        "protony": 49,
        "neutrony": 66,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,3",
        "masa_atomowa": "114.818 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ind (In)49",
            "en": "Indium (In)49"
        },
        "snazwa": {
            "pl": "Ind",
            "en": "Indium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Sn",
        "kategoria_code": "metale-bloku-p",
        "grupa": 14,
        "okres": 5,
        "gestosc": "7.287 g/cm³",
        "temp_topnienia": "231.93°C",
        "temp_wrzenia": "2602°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 50,
        "protony": 50,
        "neutrony": 69,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,4",
        "masa_atomowa": "118.71 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Cyna (Sn)50",
            "en": "Tin (Sn)50"
        },
        "snazwa": {
            "pl": "Cyna",
            "en": "Tin"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Sb",
        "kategoria_code": "polmetale",
        "grupa": 15,
        "okres": 5,
        "gestosc": "6.685 g/cm³",
        "temp_topnienia": "630.63°C ",
        "temp_wrzenia": "1587°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 51,
        "protony": 51,
        "neutrony": 71,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,5",
        "masa_atomowa": "121.760 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Antymon (Sb)51",
            "en": "Antimony (Sb)51"
        },
        "snazwa": {
            "pl": "Antymon",
            "en": "Antimony"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Te",
        "kategoria_code": "polmetale",
        "grupa": 16,
        "okres": 5,
        "gestosc": "6.232 g/cm³",
        "temp_topnienia": "449.51°C",
        "temp_wrzenia": "988°C",
        "odkryty_przez": "Martin Heinrich Klaproth, Franz-Joseph Müller von Reichenstein",
        "rok_odkrycia": "1782",
        "elektrony": 52,
        "protony": 52,
        "neutrony": 76,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,6",
        "masa_atomowa": "127.6 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tellur (Te)52",
            "en": "Tellurium (Te)52"
        },
        "snazwa": {
            "pl": "Tellur",
            "en": "Tellurium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "I",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 5,
        "gestosc": "4.93 g/cm³",
        "temp_topnienia": "113.7°C",
        "temp_wrzenia": "184.4°C ",
        "odkryty_przez": "Bernard Courtois",
        "rok_odkrycia": "1811",
        "elektrony": 53,
        "protony": 53,
        "neutrony": 74,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,7",
        "masa_atomowa": "126.9045 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Jod (I)53",
            "en": "Iodine (I)53"
        },
        "snazwa": {
            "pl": "Jod",
            "en": "Iodine"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Xe",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 5,
        "gestosc": "0.005887 g/cm³",
        "temp_topnienia": "-111.79°C",
        "temp_wrzenia": "-108.12°C ",
        "odkryty_przez": "William Ramsay, Morris Travers",
        "rok_odkrycia": "1898",
        "elektrony": 54,
        "protony": 54,
        "neutrony": 77,
        "liczba_powlok": 5,
        "rozklad_powlok": "2,8,18,18,8",
        "masa_atomowa": "131.29 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Ksenon (Xe)54",
            "en": "Xenon (Xe)54"
        },
        "snazwa": {
            "pl": "Ksenon",
            "en": "Xenon"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Cs",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 6,
        "gestosc": "1.93 g/cm³",
        "temp_topnienia": "28.44°C ",
        "temp_wrzenia": "671°C ",
        "odkryty_przez": "Gustav Kirchhoff, Robert Bunsen",
        "rok_odkrycia": "1860",
        "elektrony": 55,
        "protony": 55,
        "neutrony": 78,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,18,8,1",
        "masa_atomowa": "132.9054520 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Cez (Cs)55",
            "en": "Caesium (Cs)55"
        },
        "snazwa": {
            "pl": "Cez",
            "en": "Caesium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Ba",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 6,
        "gestosc": "3.62 g/cm³",
        "temp_topnienia": "727°C",
        "temp_wrzenia": "1897°C",
        "odkryty_przez": "Humphry Davy, Carl Wilhelm Scheele",
        "rok_odkrycia": "1808",
        "elektrony": 56,
        "protony": 56,
        "neutrony": 81,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,18,8,2",
        "masa_atomowa": "137.33 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline Earth Metals"
        },
        "postac": {
            "pl": "stała",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Bar (Ba)56",
            "en": "Barium (Ba)56"
        },
        "snazwa": {
            "pl": "Bar",
            "en": "Barium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "La",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "6.15 g/cm³",
        "temp_topnienia": "918°C",
        "temp_wrzenia": "3464°C",
        "odkryty_przez": "Carl Gustaf Mosander",
        "rok_odkrycia": "1839",
        "elektrony": 57,
        "protony": 57,
        "neutrony": 82,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,18,9,2",
        "masa_atomowa": "138.9055 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Lantan (La)57",
            "en": "Lanthanum (La)57"
        },
        "snazwa": {
            "pl": "Lantan",
            "en": "Lanthanum"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Ce",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "6.770 g/cm³",
        "temp_topnienia": "798°C",
        "temp_wrzenia": "3424°C",
        "odkryty_przez": "Jöns Jacob Berzelius, Martin Heinrich Klaproth, Carl Gustaf Mosander",
        "rok_odkrycia": "1803",
        "elektrony": 58,
        "protony": 58,
        "neutrony": 82,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,19,9,2",
        "masa_atomowa": "140.116 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Cer (Ce)58",
            "en": "Cerium (Ce)58"
        },
        "snazwa": {
            "pl": "Cer",
            "en": "Cerium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Pr",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "6.77 g/cm³",
        "temp_topnienia": "931°C",
        "temp_wrzenia": "3520°C",
        "odkryty_przez": "Carl Auer (Baron von Welsbach)",
        "rok_odkrycia": "1885",
        "elektrony": 59,
        "protony": 59,
        "neutrony": 82,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,21,8,2",
        "masa_atomowa": "140.90766 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Prazeodym (Pr)59",
            "en": "Praseodymium (Pr)59"
        },
        "snazwa": {
            "pl": "Prazeodym",
            "en": "Praseodymium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Nd",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "7.01 g/cm³",
        "temp_topnienia": "1021°C",
        "temp_wrzenia": "3074°C",
        "odkryty_przez": "Carl Auer (Baron von Welsbach) ",
        "rok_odkrycia": "1885",
        "elektrony": 60,
        "protony": 60,
        "neutrony": 84,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,22,8,2",
        "masa_atomowa": "144.24 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Neodym (Nd)60",
            "en": "Neodymium (Nd)60"
        },
        "snazwa": {
            "pl": "Neodym",
            "en": "Neodymium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Pm",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "7.26 g/cm³",
        "temp_topnienia": "1042°C",
        "temp_wrzenia": "3000°C",
        "odkryty_przez": "Jacob A. Marinsky, Charles D. Coryell, Lawrence E. Glendenin",
        "rok_odkrycia": "1945",
        "elektrony": 61,
        "protony": 61,
        "neutrony": 84,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,23,8,2",
        "masa_atomowa": "144.91276 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Promet (Pm)61",
            "en": "Promethium (Pm)61"
        },
        "snazwa": {
            "pl": "Promet",
            "en": "Promethium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Sm",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "7.52 g/cm³",
        "temp_topnienia": "1074°C",
        "temp_wrzenia": "1794°C",
        "odkryty_przez": "Paul-Émile Lecoq de Boisbaudran, Eugène-Anatole Demarçay",
        "rok_odkrycia": "1879",
        "elektrony": 62,
        "protony": 62,
        "neutrony": 88,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,24,8,2",
        "masa_atomowa": "150.36 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Samar (Sm)62",
            "en": "Samarium (Sm)62"
        },
        "snazwa": {
            "pl": "Samar",
            "en": "Samarium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny",
            "en": "natural"
        }
    },
    {
        "symbol": "Eu",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "5.24 g/cm³",
        "temp_topnienia": "822°C",
        "temp_wrzenia": "1529°C",
        "odkryty_przez": "Paul-Émile Lecoq de Boisbaudran, Eugène-Anatole Demarçay",
        "rok_odkrycia": "1901",
        "elektrony": 63,
        "protony": 63,
        "neutrony": 89,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,25,8,2",
        "masa_atomowa": "151.964 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Europ (Eu)63",
            "en": "Europium (Eu)63"
        },
        "snazwa": {
            "pl": "Europ",
            "en": "Europium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Gd",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "7.90 g/cm³",
        "temp_topnienia": "1313°C",
        "temp_wrzenia": "3273°C",
        "odkryty_przez": "Paul-Émile Lecoq de Boisbaudran, Jean Charles Galissard de Marignac",
        "rok_odkrycia": "1880",
        "elektrony": 64,
        "protony": 64,
        "neutrony": 93,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,25,9,2",
        "masa_atomowa": "157.2 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Gadolin (Gd)64",
            "en": "Gadolinium (Gd)64"
        },
        "snazwa": {
            "pl": "Gadolin",
            "en": "Gadolinium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Tb",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "8.23 g/cm³",
        "temp_topnienia": "1356°C ",
        "temp_wrzenia": "3230°C",
        "odkryty_przez": "Carl Gustaf Mosander",
        "rok_odkrycia": "1843",
        "elektrony": 65,
        "protony": 65,
        "neutrony": 94,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,27,8,2",
        "masa_atomowa": "158.92535 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Terb (Tb)65",
            "en": "Terbium (Tb)65"
        },
        "snazwa": {
            "pl": "Terb",
            "en": "Terbium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Dy",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "8.55 g/cm³",
        "temp_topnienia": "1412°C ",
        "temp_wrzenia": "2567°C",
        "odkryty_przez": "Paul-Émile Lecoq de Boisbaudran",
        "rok_odkrycia": "1886",
        "elektrony": 66,
        "protony": 66,
        "neutrony": 97,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,28,8,2",
        "masa_atomowa": "162.500 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Dysproz (Dy)66",
            "en": "Dysprosium (Dy)66"
        },
        "snazwa": {
            "pl": "Dysproz",
            "en": "Dysprosium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ho",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "8.80 g/cm³",
        "temp_topnienia": "1474°C",
        "temp_wrzenia": "2700°C",
        "odkryty_przez": "Per Teodor Cleve, Marc Delafontaine, Jacques-Louis Soret",
        "rok_odkrycia": "1878",
        "elektrony": 67,
        "protony": 67,
        "neutrony": 98,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,29,8,2",
        "masa_atomowa": "164.93033 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Holm (Ho)67",
            "en": "Holmium (Ho)67"
        },
        "snazwa": {
            "pl": "Holm",
            "en": "Holmium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Er",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "9.07 g/cm³",
        "temp_topnienia": "1529°C",
        "temp_wrzenia": "2868°C",
        "odkryty_przez": "Carl Gustaf Mosander",
        "rok_odkrycia": "1843",
        "elektrony": 68,
        "protony": 68,
        "neutrony": 99,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,30,8,2",
        "masa_atomowa": "167.26 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Erb (Er)68",
            "en": "Erbium (Er)68"
        },
        "snazwa": {
            "pl": "Erb",
            "en": "Erbium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Tm",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "9.32 g/cm³",
        "temp_topnienia": "1545°C ",
        "temp_wrzenia": "1950°C ",
        "odkryty_przez": "Per Teodor Cleve",
        "rok_odkrycia": "1879",
        "elektrony": 69,
        "protony": 69,
        "neutrony": 100,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,31,8,2",
        "masa_atomowa": "168.93422 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tul (Tm)69",
            "en": "Thulium  (Tm)69"
        },
        "snazwa": {
            "pl": "Tul",
            "en": "Thulium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Yb",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "6.90 g/cm³",
        "temp_topnienia": "819°C",
        "temp_wrzenia": "1196°C ",
        "odkryty_przez": "Jean Charles Galissard de Marignac",
        "rok_odkrycia": "1878",
        "elektrony": 70,
        "protony": 70,
        "neutrony": 103,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,8,2",
        "masa_atomowa": "173.05 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lanthanide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Iterb (Yb)70",
            "en": "Ytterbium (Yb)70"
        },
        "snazwa": {
            "pl": "Iterb",
            "en": "Ytterbium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Lu",
        "kategoria_code": "lantanowce",
        "grupa": 3,
        "okres": 6,
        "gestosc": "9.84 g/cm³",
        "temp_topnienia": "1663°C",
        "temp_wrzenia": "3402°C ",
        "odkryty_przez": "Georges Urbain ",
        "rok_odkrycia": "1907",
        "elektrony": 71,
        "protony": 71,
        "neutrony": 104,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,9,2",
        "masa_atomowa": "174.9668 u",
        "kategoria": {
            "pl": "Lantanowce",
            "en": "Lantanowce"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Lutet (Lu)71",
            "en": "Lutetium (Lu)71"
        },
        "snazwa": {
            "pl": "Lutet",
            "en": "Lutetium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Hf",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 4,
        "okres": 6,
        "gestosc": "13.3 g/cm³",
        "temp_topnienia": "2233°C",
        "temp_wrzenia": "4603°C ",
        "odkryty_przez": "George de Hevesy, Dirk Coster",
        "rok_odkrycia": "1923",
        "elektrony": 72,
        "protony": 72,
        "neutrony": 106,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,10,2",
        "masa_atomowa": "178.49 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Hafn (Hf)72",
            "en": "Hafnium (Hf)72"
        },
        "snazwa": {
            "pl": "Hafn",
            "en": "Hafnium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ta",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 5,
        "okres": 6,
        "gestosc": "16.4 g/cm³",
        "temp_topnienia": "3017°C",
        "temp_wrzenia": "5458°C",
        "odkryty_przez": " Anders- Gustav Ekeberg ",
        "rok_odkrycia": "1802",
        "elektrony": 73,
        "protony": 73,
        "neutrony": 108,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,11,2",
        "masa_atomowa": "180.9479 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tantal (Ta)73",
            "en": "Tantalum  (Ta)73"
        },
        "snazwa": {
            "pl": "Tantal",
            "en": "Tantalum"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "W",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 6,
        "okres": 6,
        "gestosc": "19.3 g/cm³",
        "temp_topnienia": "3422°C",
        "temp_wrzenia": "5555°C",
        "odkryty_przez": "Carl Wilhelm Scheele",
        "rok_odkrycia": "1783",
        "elektrony": 74,
        "protony": 74,
        "neutrony": 110,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,12,2",
        "masa_atomowa": "183.84 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Wolfram (W)74",
            "en": "Tungsten (W)74"
        },
        "snazwa": {
            "pl": "Wolfram",
            "en": "Tungsten"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Re",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 7,
        "okres": 6,
        "gestosc": "20.8 g/cm³",
        "temp_topnienia": "3186°C",
        "temp_wrzenia": "5596°C",
        "odkryty_przez": "Walter Noddack, Ida Noddack, Otto Berg",
        "rok_odkrycia": "1925",
        "elektrony": 75,
        "protony": 75,
        "neutrony": 111,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,13,2",
        "masa_atomowa": "186.207 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ren (Re)75",
            "en": "Rhenium (Re)75"
        },
        "snazwa": {
            "pl": "Ren",
            "en": "Rhenium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Os",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 8,
        "okres": 6,
        "gestosc": "22.57 g/cm³",
        "temp_topnienia": "3033°C ",
        "temp_wrzenia": "5012°C",
        "odkryty_przez": "Smithson Tennant",
        "rok_odkrycia": "1803",
        "elektrony": 76,
        "protony": 76,
        "neutrony": 114,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,14,2",
        "masa_atomowa": "190.2 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Osm (Os)76",
            "en": "Osmium (Os)76"
        },
        "snazwa": {
            "pl": "Osm",
            "en": "Osmium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Ir",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 9,
        "okres": 6,
        "gestosc": "22.42 g/cm³",
        "temp_topnienia": "2446°C",
        "temp_wrzenia": "4428°C ",
        "odkryty_przez": "Smithson Tennant",
        "rok_odkrycia": "1803",
        "elektrony": 77,
        "protony": 77,
        "neutrony": 115,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,15,2",
        "masa_atomowa": "192.22 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Iryd (Ir)77",
            "en": "Iridium (Ir)77"
        },
        "snazwa": {
            "pl": "Iryd",
            "en": "Iridium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Pt",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 10,
        "okres": 6,
        "gestosc": "21.46 g/cm³",
        "temp_topnienia": "1768.4°C ",
        "temp_wrzenia": "3825°C",
        "odkryty_przez": "Antonio de Ulloa",
        "rok_odkrycia": "1735",
        "elektrony": 78,
        "protony": 78,
        "neutrony": 117,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,17,1",
        "masa_atomowa": "195.08 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Platyna (Pt)78",
            "en": "Platinum (Pt)78"
        },
        "snazwa": {
            "pl": "Platyna",
            "en": "Platinum"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Au",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 11,
        "okres": 6,
        "gestosc": "19.282 g/cm³",
        "temp_topnienia": "1064.18°C",
        "temp_wrzenia": "2856°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 79,
        "protony": 79,
        "neutrony": 118,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,1",
        "masa_atomowa": "196.96657 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Złoto (Au)79",
            "en": "Gold (Au)79"
        },
        "snazwa": {
            "pl": "Złoto",
            "en": "Gold"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Hg",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 12,
        "okres": 6,
        "gestosc": "13,546 g/cm³",
        "temp_topnienia": "-38.83°C ",
        "temp_wrzenia": "356.73°C",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 80,
        "protony": 80,
        "neutrony": 121,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,2",
        "masa_atomowa": "200.59 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "ciecz",
            "en": "liquid"
        },
        "nazwa": {
            "pl": "Rtęć (Hg)80",
            "en": "Mercury (Hg)80"
        },
        "snazwa": {
            "pl": "Rtęć",
            "en": "Mercury"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Tl",
        "kategoria_code": "metale-bloku-p",
        "grupa": 13,
        "okres": 6,
        "gestosc": "11.8 g/cm³",
        "temp_topnienia": "304°C",
        "temp_wrzenia": "1473°C",
        "odkryty_przez": "William Crookes",
        "rok_odkrycia": "1861",
        "elektrony": 81,
        "protony": 81,
        "neutrony": 123,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,3",
        "masa_atomowa": "204.383 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tal (TI)81",
            "en": "Thallium (TI)81"
        },
        "snazwa": {
            "pl": "Tal",
            "en": "Thallium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Pb",
        "kategoria_code": "metale-bloku-p",
        "grupa": 14,
        "okres": 6,
        "gestosc": "11.342 g/cm³",
        "temp_topnienia": "327.46°C",
        "temp_wrzenia": "1749°C ",
        "odkryty_przez": "",
        "rok_odkrycia": "",
        "elektrony": 82,
        "protony": 82,
        "neutrony": 125,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,4",
        "masa_atomowa": "207 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ołów (Pb)82",
            "en": "Lead (Pb)82"
        },
        "snazwa": {
            "pl": "Ołów",
            "en": "Lead"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Bi",
        "kategoria_code": "metale-bloku-p",
        "grupa": 15,
        "okres": 6,
        "gestosc": "9.807 g/cm³",
        "temp_topnienia": "271.40°C ",
        "temp_wrzenia": "1564°C",
        "odkryty_przez": "Claude François Geoffroy",
        "rok_odkrycia": "1753",
        "elektrony": 83,
        "protony": 83,
        "neutrony": 126,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,5",
        "masa_atomowa": "208.98040 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Bizmut (Bi)83",
            "en": "Bismuth (Bi)83"
        },
        "snazwa": {
            "pl": "Bizmut",
            "en": "Bismuth"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Po",
        "kategoria_code": "polmetale",
        "grupa": 16,
        "okres": 6,
        "gestosc": "9.32 g/cm³",
        "temp_topnienia": "254°C",
        "temp_wrzenia": "962°C",
        "odkryty_przez": "Marie Curie, Pierre Curie",
        "rok_odkrycia": "1898",
        "elektrony": 84,
        "protony": 84,
        "neutrony": 126,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,6",
        "masa_atomowa": "208.98243 u",
        "kategoria": {
            "pl": "Półmetale",
            "en": "Metalloids"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Polon (Po)84",
            "en": "Polonium (Po)84"
        },
        "snazwa": {
            "pl": "Polon",
            "en": "Polonium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "At",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 6,
        "gestosc": "7 g/cm3",
        "temp_topnienia": "302°C",
        "temp_wrzenia": "337°C",
        "odkryty_przez": "Emilio Segrè",
        "rok_odkrycia": "1940",
        "elektrony": 85,
        "protony": 85,
        "neutrony": 125,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,7",
        "masa_atomowa": "209.98715 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Astat (At)85",
            "en": "Astatine (At)85"
        },
        "snazwa": {
            "pl": "Astat",
            "en": "Astatine"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Rn",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 6,
        "gestosc": "0.00973 g/cm³",
        "temp_topnienia": "-71°C",
        "temp_wrzenia": "-61.7°C",
        "odkryty_przez": "Friedrich Ernst Dorn",
        "rok_odkrycia": "1900",
        "elektrony": 86,
        "protony": 86,
        "neutrony": 136,
        "liczba_powlok": 6,
        "rozklad_powlok": "2,8,18,32,18,8",
        "masa_atomowa": "222.01758 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz",
            "en": "gas"
        },
        "nazwa": {
            "pl": "Radon (Rn)86",
            "en": "Radon (Rn)86"
        },
        "snazwa": {
            "pl": "Radon",
            "en": "Radon"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Fr",
        "kategoria_code": "metale-alkaliczne",
        "grupa": 1,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "27°C",
        "temp_wrzenia": "680°C",
        "odkryty_przez": "Marguerite Catherine Perey",
        "rok_odkrycia": "1939",
        "elektrony": 87,
        "protony": 87,
        "neutrony": 136,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,18,8,1",
        "masa_atomowa": "223.01973 u",
        "kategoria": {
            "pl": "Metale alkaliczne",
            "en": "Alkali metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Frans (Fr)87",
            "en": "Francium (Fr)87"
        },
        "snazwa": {
            "pl": "Frans",
            "en": "Francium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Ra",
        "kategoria_code": "metale-ziem-alkalicznych",
        "grupa": 2,
        "okres": 7,
        "gestosc": "5 g/cm³",
        "temp_topnienia": "700°C",
        "temp_wrzenia": "1737°C",
        "odkryty_przez": "Marie Curie, Pierre Curie",
        "rok_odkrycia": "1898",
        "elektrony": 88,
        "protony": 88,
        "neutrony": 138,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,18,8,2",
        "masa_atomowa": "226.02541 u",
        "kategoria": {
            "pl": "Metale ziem alkalicznych",
            "en": "Alkaline earth metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Rad (Ra)88",
            "en": "Radium (Ra)88"
        },
        "snazwa": {
            "pl": "Rad",
            "en": "Radium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Ac",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "10.07 g/cm³",
        "temp_topnienia": "1051°C ",
        "temp_wrzenia": "3198°C",
        "odkryty_przez": "André-Louis Debierne",
        "rok_odkrycia": "1899",
        "elektrony": 89,
        "protony": 89,
        "neutrony": 138,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,18,9,2",
        "masa_atomowa": "227.02775 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Aktyn (Ac)89",
            "en": "Actinium (Ac)89"
        },
        "snazwa": {
            "pl": "Aktyn",
            "en": "Actinium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Th",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "11.72 g/cm³",
        "temp_topnienia": "1750°C",
        "temp_wrzenia": "4788°C",
        "odkryty_przez": "Jöns Jacob Berzelius",
        "rok_odkrycia": "1828",
        "elektrony": 90,
        "protony": 90,
        "neutrony": 142,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,18,10,2",
        "masa_atomowa": "232.038 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Tor (Th)90",
            "en": "Thotium (Th)90"
        },
        "snazwa": {
            "pl": "Tor",
            "en": "Thotium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Pa",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "15.37 g/cm³",
        "temp_topnienia": "1572°C ",
        "temp_wrzenia": "4027°C",
        "odkryty_przez": "K. Fajans and O. H. Gohring ",
        "rok_odkrycia": "1913",
        "elektrony": 91,
        "protony": 91,
        "neutrony": 140,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,20,9,2",
        "masa_atomowa": "231.03588 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Protaktyn (Pa)91",
            "en": "Protactinium (Pa)91"
        },
        "snazwa": {
            "pl": "Protaktyn",
            "en": "Protactinium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "U",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "18.95 g/cm³",
        "temp_topnienia": "1133°C",
        "temp_wrzenia": "4131°C",
        "odkryty_przez": "Martin Heinrich Klaproth",
        "rok_odkrycia": "1789",
        "elektrony": 92,
        "protony": 92,
        "neutrony": 146,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,21,9,2",
        "masa_atomowa": "238.0289 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Uran (U)92",
            "en": "Uranium (U)92"
        },
        "snazwa": {
            "pl": "Uran",
            "en": "Uranium"
        },
        "wyst_w_przyrodzie": {
            "pl": "naturalny ",
            "en": "natural"
        }
    },
    {
        "symbol": "Np",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "20.25 g/cm³",
        "temp_topnienia": "644°C",
        "temp_wrzenia": "3902°C",
        "odkryty_przez": "Edwin McMillan, Philip Abelson",
        "rok_odkrycia": "1940",
        "elektrony": 93,
        "protony": 93,
        "neutrony": 144,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,22,9,2",
        "masa_atomowa": "237.048172 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Neptun (Np)93",
            "en": "Neptunium (Np)93"
        },
        "snazwa": {
            "pl": "Neptun",
            "en": "Neptunium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Pu",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "19.84 g/cm³",
        "temp_topnienia": "640°C ",
        "temp_wrzenia": "3228°C",
        "odkryty_przez": "Glenn T. Seaborg, Edwin McMillan, Arthur Wahl, Joseph W. Kennedy",
        "rok_odkrycia": "1940",
        "elektrony": 94,
        "protony": 94,
        "neutrony": 150,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,24,8,2",
        "masa_atomowa": "244.06420 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Pluton (Pu)94",
            "en": "Plutonium (Pu)94"
        },
        "snazwa": {
            "pl": "Pluton",
            "en": "Plutonium"
        },
        "wyst_w_przyrodzie": {
            "pl": "z rozpadów ",
            "en": "from decays"
        }
    },
    {
        "symbol": "Am ",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "13.69 g/cm³",
        "temp_topnienia": "1176°C",
        "temp_wrzenia": "2011°C",
        "odkryty_przez": "Glenn T. Seaborg, Albert Ghiorso, Ralph A. James",
        "rok_odkrycia": "1944",
        "elektrony": 95,
        "protony": 95,
        "neutrony": 148,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,25,8,2",
        "masa_atomowa": "243.061380 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ameryk (Am)95",
            "en": "Americium (Am)95"
        },
        "snazwa": {
            "pl": "Ameryk",
            "en": "Americium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Cm",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "13.51 g/cm³",
        "temp_topnienia": "1345°C",
        "temp_wrzenia": "3100°C",
        "odkryty_przez": "Glenn T. Seaborg, Ralph A. James, Albert Ghiorso,",
        "rok_odkrycia": "1944",
        "elektrony": 96,
        "protony": 96,
        "neutrony": 151,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,25,9,2",
        "masa_atomowa": "247.07035 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Kiur (Cm)96",
            "en": "Ciurium (Cm)96"
        },
        "snazwa": {
            "pl": "Kiur",
            "en": "Ciurium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Bk",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "14 g/cm³",
        "temp_topnienia": "1050°C ",
        "temp_wrzenia": "2627°C",
        "odkryty_przez": "Stanley G. Thompson, Glenn T. Seaborg, Kenneth Street, Jr., Albert Ghiors",
        "rok_odkrycia": "1949",
        "elektrony": 97,
        "protony": 97,
        "neutrony": 150,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,27,8,2",
        "masa_atomowa": "247.07031 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Berkel (Bk)97",
            "en": "Berkelium (Bk)97"
        },
        "snazwa": {
            "pl": "Berkel",
            "en": "Berkelium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Cf",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "15.1 g/cm3",
        "temp_topnienia": "900°C",
        "temp_wrzenia": "1470°C",
        "odkryty_przez": "tanley G. Thompson, Glenn T. Seaborg, Kenneth Street, Jr. Albert Ghiorso",
        "rok_odkrycia": "1950",
        "elektrony": 98,
        "protony": 98,
        "neutrony": 153,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,28,8,2",
        "masa_atomowa": "251.07959 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Kaliforn (Cf)98",
            "en": "Californium (Cf)98"
        },
        "snazwa": {
            "pl": "Kaliforn",
            "en": "Californium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Es",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "8.84 g/cm3",
        "temp_topnienia": "860°C",
        "temp_wrzenia": "996°C",
        "odkryty_przez": "Albert Ghiorso ",
        "rok_odkrycia": "1952",
        "elektrony": 99,
        "protony": 99,
        "neutrony": 153,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,29,8,2",
        "masa_atomowa": "252.0830 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Einstein (Es)99",
            "en": "Einsteinium (Es)99"
        },
        "snazwa": {
            "pl": "Einstein",
            "en": "Einsteinium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Fm",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "1527°C",
        "temp_wrzenia": "",
        "odkryty_przez": "Albert Ghiorso ",
        "rok_odkrycia": "1953",
        "elektrony": 100,
        "protony": 100,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,30,8,2",
        "masa_atomowa": "257.09511 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Ferm (Fm)100",
            "en": "Fermium (Fm)100"
        },
        "snazwa": {
            "pl": "Ferm",
            "en": "Fermium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Md",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "827°C ",
        "temp_wrzenia": "",
        "odkryty_przez": "Stanley G. Thompson, Glenn T. Seaborg, Bernard G. Harvey, Gregory R. Choppin, Albert Ghiorso",
        "rok_odkrycia": "1955",
        "elektrony": 101,
        "protony": 101,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,31,8,2",
        "masa_atomowa": "258.09843 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Mendelew (Md)101",
            "en": "Mendelevium (Md)101"
        },
        "snazwa": {
            "pl": "Mendelew",
            "en": "Mendelevium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "No",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "827°C ",
        "temp_wrzenia": "",
        "odkryty_przez": "Albert Ghiorso, Glenn T. Seaborg, Torbørn Sikkeland, John R. Walton",
        "rok_odkrycia": "1957",
        "elektrony": 102,
        "protony": 102,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,8,2",
        "masa_atomowa": "259.10100 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Nobel (No)102",
            "en": "Nobelium (No)102"
        },
        "snazwa": {
            "pl": "Nobel",
            "en": "Nobelium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Lr",
        "kategoria_code": "aktynowce",
        "grupa": 3,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "1627°C",
        "temp_wrzenia": "",
        "odkryty_przez": "Albert Ghiorso, Georgi Flerov ",
        "rok_odkrycia": "1961",
        "elektrony": 103,
        "protony": 103,
        "neutrony": 159,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,8,3",
        "masa_atomowa": "266.120 u",
        "kategoria": {
            "pl": "Aktynowce",
            "en": "Actinide"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Lorens (Lr)103",
            "en": "Lawrencium (Lr)103"
        },
        "snazwa": {
            "pl": "Lorens",
            "en": "Lawrencium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Rf",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 4,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "2100°C",
        "temp_wrzenia": "5500°C",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia",
        "rok_odkrycia": "1964",
        "elektrony": 104,
        "protony": 104,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,10,2",
        "masa_atomowa": "267.122 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Rutherford (Rf)104",
            "en": "Rutherford (Rf)104"
        },
        "snazwa": {
            "pl": "Rutherford",
            "en": "Rutherford"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Db",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 5,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia",
        "rok_odkrycia": "1967",
        "elektrony": 105,
        "protony": 105,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,11,2",
        "masa_atomowa": "268.126 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Dubn (Db)105",
            "en": "Dubnium (Db)105"
        },
        "snazwa": {
            "pl": "Dubn",
            "en": "Dubnium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Sg",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 6,
        "okres": 7,
        "gestosc": "(gray form) 5.73 g/cm3 at 14 °C (57 °F)\n(yellow form) 2.03 g/cm3 at 18 °C (64 °F)",

        "gestoscPL": "(postać szara) 5,73 g/cm3 w temperaturze 14 °C (57 °F)\n(postać żółta) 2,03 g/cm3 w temperaturze 18 °C (64 °F)",

        "temp_topnienia": "(gray form) 814 °C (1,497 °F) at 36 atmospheres pressure",
        "temp_topnieniaPL": "(postać szara) 814 °C (1.497 °F) przy ciśnieniu 36 atmosfer",
        "temp_wrzenia": "",
        "odkryty_przez": "Albert Ghiorso ",
        "rok_odkrycia": "1974",
        "elektrony": 106,
        "protony": 106,
        "neutrony": 156,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,12,2",
        "masa_atomowa": "269.128 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Seaborg (Sg)106",
            "en": "Seaborgium (Sg)106"
        },
        "snazwa": {
            "pl": "Seaborg",
            "en": "Seaborgium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        },
    },
    {
        "symbol": "Bh",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 7,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia",
        "rok_odkrycia": "1976",
        "elektrony": 107,
        "protony": 107,
        "neutrony": 157,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,13,2",
        "masa_atomowa": "270.133 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Bohr (Bh)107",
            "en": "Bohrium (Bh)107"
        },
        "snazwa": {
            "pl": "Bohr",
            "en": "Bohrium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Hs",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 8,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Peter Armbruster, Gottfried Münzenbe",
        "rok_odkrycia": "1984",
        "elektrony": 108,
        "protony": 108,
        "neutrony": 161,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,14,2",
        "masa_atomowa": "269.1336 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Has (Hs)108",
            "en": "Hassium (Hs)108"
        },
        "snazwa": {
            "pl": "Has",
            "en": "Hassium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Mt",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 9,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Peter Armbruster, Gottfried Münzenbe",
        "rok_odkrycia": "1982",
        "elektrony": 109,
        "protony": 109,
        "neutrony": 159,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,15,2",
        "masa_atomowa": "277.154 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały",
            "en": "solid"
        },
        "nazwa": {
            "pl": "Meitner (Mt)109",
            "en": "Meitnerium (Mt)109"
        },
        "snazwa": {
            "pl": "Meitner",
            "en": "Meitnerium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Ds",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 10,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Peter Armbruster, Gottfried Münzenber",
        "rok_odkrycia": "1994",
        "elektrony": 110,
        "protony": 110,
        "neutrony": 171,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,16,2",
        "masa_atomowa": "282.166 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Darmsztadt (Ds)110",
            "en": "Darmstadtium (Ds)110"
        },
        "snazwa": {
            "pl": "Darmsztadt",
            "en": "Darmstadtium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Rg",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 11,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Peter Armbruster, Gottfried Münzenber",
        "rok_odkrycia": "1994",
        "elektrony": 111,
        "protony": 111,
        "neutrony": 170,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,17,2",
        "masa_atomowa": "282.169 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Roentgen (Rg)111",
            "en": "Roentgenium (Rg)111"
        },
        "snazwa": {
            "pl": "Roentgen",
            "en": "Roentgenium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Cn",
        "kategoria_code": "metale-przejsciowe",
        "grupa": 12,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Peter Armbruster, Gottfried Münzenber",
        "rok_odkrycia": "1996",
        "elektrony": 112,
        "protony": 112,
        "neutrony": 173,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,2",
        "masa_atomowa": "286.179 u",
        "kategoria": {
            "pl": "Metale przejściowe",
            "en": "Transition Metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Kopernik (Cn)112",
            "en": "Copernicium (Cn)112"
        },
        "snazwa": {
            "pl": "Kopernik",
            "en": "Copernicium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Nh",
        "kategoria_code": "metale-bloku-p",
        "grupa": 13,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "RIKEN Nishina Center for Accelerator-based Science in Wako, Japan",
        "rok_odkrycia": "2004",
        "elektrony": 113,
        "protony": 113,
        "neutrony": 173,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,3",
        "masa_atomowa": "286.182 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Nihon (Nh)113",
            "en": "Nihonium (Nh)113"
        },
        "snazwa": {
            "pl": "Nihon",
            "en": "Nihonium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Fl",
        "kategoria_code": "metale-bloku-p",
        "grupa": 14,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia ",
        "rok_odkrycia": "1998",
        "elektrony": 114,
        "protony": 114,
        "neutrony": 173,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,4",
        "masa_atomowa": "290.192 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Flerow (Fl)114",
            "en": "Flerovium(Fl) 114"
        },
        "snazwa": {
            "pl": "Flerow",
            "en": "Flerovium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Mc",
        "kategoria_code": "metale-bloku-p",
        "grupa": 15,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia ",
        "rok_odkrycia": "2003",
        "elektrony": 115,
        "protony": 115,
        "neutrony": 173,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,5",
        "masa_atomowa": "290.196 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Moskow (Mc) 115",
            "en": "Moscovium (Mc) 115"
        },
        "snazwa": {
            "pl": "Moskow",
            "en": "Moscovium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Lv",
        "kategoria_code": "metale-bloku-p",
        "grupa": 16,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia ",
        "rok_odkrycia": "2000",
        "elektrony": 116,
        "protony": 116,
        "neutrony": 175,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,6",
        "masa_atomowa": "293.205 u",
        "kategoria": {
            "pl": "Metale bloku p",
            "en": "Post-transition metals"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Liwermor (Lv)116",
            "en": "Liwermorium (Lv)116"
        },
        "snazwa": {
            "pl": "Liwermor",
            "en": "Liwermorium"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Ts",
        "kategoria_code": "halogeny",
        "grupa": 17,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia, U.S. Department of Energy's Lawrence Livermore National Laboratory and Oak Ridge National Laboratory",
        "rok_odkrycia": "2010",
        "elektrony": 117,
        "protony": 117,
        "neutrony": 177,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,7",
        "masa_atomowa": "294.211 u",
        "kategoria": {
            "pl": "Halogeny",
            "en": "Halogens"
        },
        "postac": {
            "pl": "stały (przypuszczalnie)",
            "en": "solid (expected)"
        },
        "nazwa": {
            "pl": "Tenes (Ts)117",
            "en": "Tennessine (Ts)117"
        },
        "snazwa": {
            "pl": "Tenes",
            "en": "Tennessine"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    },
    {
        "symbol": "Og",
        "kategoria_code": "gazy-szlachetne",
        "grupa": 18,
        "okres": 7,
        "gestosc": "",
        "temp_topnienia": "",
        "temp_wrzenia": "",
        "odkryty_przez": "Joint Institute for Nuclear Research in Dubna, Russia, U.S. Department of Energy's Lawrence Livermore National Laboratory ",
        "rok_odkrycia": "2006",
        "elektrony": 118,
        "protony": 118,
        "neutrony": 176,
        "liczba_powlok": 7,
        "rozklad_powlok": "2,8,18,32,32,18,8",
        "masa_atomowa": "295.216 u",
        "kategoria": {
            "pl": "Gazy szlachetne",
            "en": "Noble gases"
        },
        "postac": {
            "pl": "gaz (przypuszczalnie)",
            "en": "gas (expected)"
        },
        "nazwa": {
            "pl": "Oganeson (Og)118",
            "en": "Oganeson (Og)118"
        },
        "snazwa": {
            "pl": "Oganeson",
            "en": "Oganeson"
        },
        "wyst_w_przyrodzie": {
            "pl": "syntetyczny",
            "en": "synthetic"
        }
    }
];